import React, { useState, useCallback, useMemo } from 'react';
import { AccordionContainerProps } from '../types';
import { populateWithSlot } from './utils/populateWithSlot';
import { AccordionAnimated } from './components/AccordionAnimated';
import { AccordionSimple } from './components/AccordionSimple';
import { st, classes } from './AccordionContainer.component.st.css';

export const AccordionContainer: React.FC<AccordionContainerProps> = ({
  id,
  items: rawItems,
  slots,
  multiple,
  opened: propOpened,
  animated,
  className,
}) => {
  const [opened, setOpened] = useState<Array<string>>(propOpened);

  const toggleItem = useCallback(
    (itemId: string) =>
      setOpened(prevOpened => {
        if (prevOpened.includes(itemId)) {
          return prevOpened.filter(item => item !== itemId);
        }
        return multiple ? [...prevOpened, itemId] : [itemId];
      }),
    [multiple],
  );

  const items = useMemo(
    () => populateWithSlot(rawItems, slots),
    [rawItems, slots],
  );

  const Accordion = animated ? AccordionAnimated : AccordionSimple;

  return (
    <div className={st(classes.root, className)} id={id}>
      {items.map(item => (
        <Accordion
          key={item.id}
          item={item}
          toggleItem={toggleItem}
          isOpened={opened.includes(item.id)}
        />
      ))}
    </div>
  );
};

export default AccordionContainer;
